import { $http } from '@/utils';
import { MD5 } from 'crypto-js';

/**
 * @namespace Service
 * @class Insight
 * @exports Service/Cms/Page
 * @description API Insight Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class Page {
	/**
	 * @static @name list
	 * @description Get all pages as a list that can be manipulated through post body properties
	 * @returns {Object} Promise a http response
	 */
	static list(payload, domain, cache = true) {
		const cacheHash = MD5(JSON.stringify({ payload, domain })).toString();
		return $http.post(
			'cms/page/list',
			{ ...payload, cacheHash },
			{
				cache,
				cachePath: `table-cms-page-${cacheHash}`
			}
		);
	}

	/**
	 * @static @name get
	 * @description Get a single news item by id
	 * @returns {Object} Promise a http response
	 */
	static get(id) {
		return $http.get(`cms/page/${id}`);
	}
}
